import React, { useId, useState } from "react";
import { Card } from "react-bootstrap";
import { FaChevronDown, FaChevronRight, FaEye } from "react-icons/fa";
import "./AccordionSection.css";

export interface AccordionSectionProps {
  id?: string;
  title: string;
  linkModelo?: string | null;
  children: React.ReactNode;
  defaultOpen?: boolean;
  isOpen?: boolean;
  onToggle?: () => void;
  titlePending?: boolean;
  titleAdequacaoAguardando?: boolean;
  
  titleAdequacaoRespondida?: boolean;
}

const AccordionSection: React.FC<AccordionSectionProps> = ({
  id,
  title,
  linkModelo,
  children,
  defaultOpen = false,
  isOpen: isOpenProp,
  onToggle,
  titlePending = false,
  titleAdequacaoAguardando = false,
  titleAdequacaoRespondida = false,
}) => {
  const pendingDescId = useId();
  const [localOpen, setLocalOpen] = useState(defaultOpen);
  const isControlled = isOpenProp !== undefined && typeof onToggle === "function";
  const isOpen = isControlled ? isOpenProp : localOpen;
  const handleToggle = isControlled ? onToggle : () => setLocalOpen((p) => !p);

  return (
    <Card id={id} className="mb-4">
      <Card.Body>
        <button
          type="button"
          onClick={handleToggle}
          className="w-100 d-flex justify-content-between align-items-center border-0 bg-transparent p-0 text-start"
          aria-expanded={isOpen}
          aria-describedby={titlePending ? pendingDescId : undefined}
        >
          <div className="d-flex align-items-center gap-2 flex-grow-1 min-w-0">
            {isOpen ? (
              <FaChevronDown className="accordion-secao-chevron" aria-hidden />
            ) : (
              <FaChevronRight className="accordion-secao-chevron" aria-hidden />
            )}
            <span className="d-inline-flex align-items-center gap-2 flex-wrap flex-grow-1 min-w-0">
              <Card.Title className="fw-bold mb-0">{title}</Card.Title>
              {titlePending ? (
                <>
                  <span id={pendingDescId} className="visually-hidden">
                    Há informações pendentes nesta secção.
                  </span>
                  <span
                    className="accordion-secao-pendente-badge"
                    aria-hidden
                    title="Pendente"
                  />
                </>
              ) : null}
              {titleAdequacaoAguardando ? (
                <span
                  className="accordion-secao-adequacao-badge"
                  aria-hidden
                  title="Adequação solicitada"
                />
              ) : null}
              {titleAdequacaoRespondida ? (
                <span
                  className="accordion-secao-retorno-sindicato-badge"
                  aria-hidden
                  title="Adequação respondida pelo sindicato"
                />
              ) : null}
            </span>
          </div>
          {linkModelo && (
            <a
              href={linkModelo}
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary text-decoration-none d-flex align-items-center"
              onClick={(e) => e.stopPropagation()}
            >
              <FaEye className="me-2" /> Ver modelo
            </a>
          )}
        </button>
        {isOpen && <div className="mt-3">{children}</div>}
      </Card.Body>
    </Card>
  );
};

export default AccordionSection;
